//@flow
import * as React from 'react'
import Paper from '@material-ui/core/Paper'
import ContainerRowSpace from '../common/ContainerRowSpace'
import ReviewQuestions from './ReviewQuestions'
import type { QualityReviewContainer$Props } from './flowTypes'


const QualityReviewContainer=(props:QualityReviewContainer$Props)=>{
    const containerTemplate = (
        <div>
            <Paper>
                <div className='container'>
                    <ContainerRowSpace />

                    <ReviewQuestions 
                        changeFieldValue={props.changeFieldValue}
                        questions={props.questions}
                    />
                </div>
            </Paper>
        </div>
    )

    return containerTemplate
}

export default QualityReviewContainer


// WEBPACK FOOTER //
// ./src/components/QualityReview/QualityReviewContainer.js